import { UserCard } from '../../UserCard'
import { userSlice } from '../../../slices/userSlice'
import { cn } from '@wellesley/ui'
import { FC } from 'react'

type UserListProps = {
  users: ReturnType<typeof userSlice.selectors.selectUsers>
  selectedUserId?: string | null
  onUserSelect: (id: string) => void
}

export const UserList: FC<UserListProps> = ({
  users,
  selectedUserId,
  onUserSelect,
}) => (
  <div className="gap-xxxs flex max-h-[325px] flex-col overflow-auto">
    {users?.map(({ username, displayName, id, avatar }) => (
      <div
        key={username}
        className={cn(
          'rounded-m hover:bg-gray-100',
          selectedUserId !== id ? 'cursor-pointer' : 'bg-gray-100',
        )}
        onClick={() => void onUserSelect(id)}
      >
        <UserCard
          username={username}
          imgUrl={avatar?.files[0]?.uri || undefined}
          avatarClassName="2xl:h-10 2xl:w-10"
          displayName={displayName}
          className="p-xxs"
          hasCheckIcon={selectedUserId === id}
        />
      </div>
    ))}
  </div>
)
